module.exports = __webpack_public_path__ + "components/country-flag/static/fm-41f9c21154edeaee2397e9ec772d6aa2.svg";